import classNames from 'classnames';

interface CarouselDotsProps {
  length: number;
  visible: number;
  size?: number;
  active: number;
}

const CarouselDots = ({
  length,
  visible,
  size = 6,
  active
}: CarouselDotsProps) => {
  const middleThreshold = Math.floor(visible / 2);
  const isAtStart = active <= middleThreshold;
  const isAtEnd = active >= length - middleThreshold - 1;

  const actualVisible = isAtStart || isAtEnd ? visible : visible + 1;

  let start = 0;
  if (isAtStart) {
    start = 0;
  } else if (isAtEnd) {
    start = length - actualVisible;
  } else {
    start = active - Math.floor(actualVisible / 2);
  }

  const end = Math.min(length, start + actualVisible);

  const getDotSize = (i: number) => {
    const isEdge =
      (actualVisible === visible + 1 && (i === 0 || i === actualVisible - 1)) ||
      (actualVisible === visible && isAtStart && i === actualVisible - 1) ||
      (actualVisible === visible && isAtEnd && i === 0);

    return `${isEdge ? size * 0.6 : size}px`;
  };

  return (
    <div className='flex space-x-1 justify-center items-center'>
      {Array.from({ length: end - start }, (_, i) => {
        const index = start + i;
        const isActive = index === active;

        return (
          <div
            key={index}
            className={`${classNames(
              'rounded-full transition-all bg-white border-0 ',
              { 'opacity-100': isActive, 'opacity-60': !isActive }
            )}`}
            style={{
              width: getDotSize(i),
              height: getDotSize(i)
            }}
          />
        );
      })}
    </div>
  );
};

export default CarouselDots;
